import {CardContent, css, styled} from '@mui/material';
import {StyledProps} from './types';

export const StyledCardContent = styled(CardContent)<StyledProps>`
	padding: 8px 16px 0px;

	&:last-child {
		padding-bottom: 0px;
	}

	${({$disableGutters}) =>
		$disableGutters &&
		css`
			padding-inline: 0;
		`}
`;
